import {useState, useRef} from 'react';
import {Select, Popover} from 'antd';
import {getOptions, TaskStatusType} from "../../api/Constants";
import {TaskStatusTag} from "./TaskStatusTag";
import {updateTaskStatus} from "../../api/Api";

export const TaskStatusWidget = ({task, onRefresh, onApiFail, allowVerified=true, props}) => {
    const [active, setActive] = useState(false);
    const optionsData = getOptions(TaskStatusType) ();
    const options = optionsData.filter(o => {
        if (allowVerified) return true;
        return o.value !== TaskStatusType.Verified;
    })

    const inputRef = useRef(null);

    const onSelect = (val) => {
        console.log(`select ${val}`)
        setActive(false);
        if (val === task.status) {
            return;
        }
        updateTaskStatus(task.id, val).then(r => {
            if (onRefresh) onRefresh();
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const onClick = () => {
        setActive(true);
        setTimeout(() => {
            inputRef.current.focus();
        }, 20)
    }

    const onBlur = () => {
        setActive(false);
    }

    let popOverContent;
    switch (task.status) {
        case TaskStatusType.Created:
            popOverContent = "Newly Created.  Set to Assigned once work has assigned"
            break;
        case TaskStatusType.Assigned:
            popOverContent = "Task has been assigned. Set to In-Progress once work has begun."
            break;
        case TaskStatusType.InProgress:
            popOverContent = "Work in-progress.  Set to Complete once work is complete."
            break;
        case TaskStatusType.Complete:
            popOverContent = "All work has been complete.  Set to Verified once work has been verified"
            break;
        case TaskStatusType.Verified:
            popOverContent = "All work has been completed and verified."
            break;
        default:
    }

    if (active) {
        return <div>
            <Popover content={popOverContent}>
                <Select ref={inputRef} value={task.status} options={options} onSelect={onSelect} onBlur={onBlur} popupMatchSelectWidth={false}/>
            </Popover>
        </div>
    } else {
        return <Popover content={popOverContent}>
            <div onClick={onClick} style={{cursor: 'pointer'}}>
                <TaskStatusTag status={task.status} />
            </div>
        </Popover>
    }
}